<template>
  <div class="indent-container" v-loading="isLoading">
    <div class="fixed-wrapper">
      <div class="order-property-wrapper">
        <ul class="order-property">
          <li class="name">物料名称</li>
          <li class="code">物料编码</li>
          <li class="quality">品项</li>
          <li class="brand">品牌</li>
          <li class="model">机型</li>
          <li class="module">模块</li>
          <li class="category">委托类型</li>
          <li class="quantity">委托数量</li>
          <li class="price">单价</li>
        </ul>
      </div>
    </div>
    <div class="order-list-wrapper" v-if="indentList.length > 0">
      <div
        class="item-wrapper"
        v-for="(item, index) in indentList"
        :key="index"
      >
        <div class="item-header">
          <div class="header-left">
            <span class="time">{{ item.createOn | date }}</span>
            <span>采购订单：{{ item.code }}</span>
          </div>
          <div class="status">状态：{{ item.state | indentStatus }}</div>
        </div>
        <div class="item-content">
          <div class="order-list">
            <div
              class="order-item"
              v-for="(item1, index1) in item.entrustDetails"
              :key="index1"
            >
              <div class="name">{{ item1.itemName }}</div>
              <div class="code">{{ item1.itemCode }}</div>
              <div class="quality">
                <el-tag :type="item1.itemQualityName | qualityType" size="mini">
                  {{ item1.itemQualityName }}
                </el-tag>
              </div>
              <div class="brand">{{ item1.brand }}</div>
              <div class="model">{{ item1.model }}</div>
              <div class="module">{{ item1.module }}</div>
              <div class="category">{{ item1.type }}</div>
              <div class="quantity">{{ item1.quantity }}</div>
              <div class="price">{{ item1.price }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="blank-replace" v-else>
      暂无数据
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      indentList: [],
      isLoading: false
    }
  },
  created() {
    this.getIndentList()
  },
  methods: {
    getIndentList() {
      this.isLoading = true
      const params = {
        state: 'Created',
        entrustType: '',
        keyword: '',
        skipCount: 0,
        maxResultCount: 10
      }
      this.$http
        .get('/api/services/inquiryApp/entrust/GetAll', params)
        .then(res => {
          this.indentList = res.result.items
          this.isLoading = false
        })
        .catch(err => {
          console.log(err)
          this.$message.error('获取数据失败！')
          this.isLoading = false
        })
    }
  }
}
</script>
<style lang="less" scoped>
.indent-container {
  height: 100%;
  width: 100%;
  min-width: 1200px;
  background-color: #ffffff;
  font-family: 'Source Han Sans CN';
  padding: 20px;
}
.indent-header {
  border-bottom: 1px solid #eff2f9;
  display: flex;
  align-items: center;
  font-size: 16px;
  padding-bottom: 15px;
  color: #2f343c;
  font-weight: 600;
}
.fixed-wrapper {
  width: 100%;
}

.order-property-wrapper {
  width: 100%;
  height: 45px;
  padding: 0 20px 0 20px;
  border-bottom: 1px solid #ededed;
  background-color: #f5f5f5;
  font-size: 14px;
  font-weight: 600;
  color: #2f343c;
  display: flex;
  align-items: center;
  .order-property {
    width: 100%;
    display: flex;
    align-items: center;
  }
}
.order-list-wrapper {
  width: 100%;
  height: 100%;
  background-color: #ffffff;
  overflow: auto;
  margin-top: 10px;
  font-size: 12px;
}
.item-wrapper {
  margin-top: 10px;
  border: 1px solid #ededed;
  &:first-child {
    margin-top: 0;
  }
  .item-header {
    height: 35px;
    padding: 0 20px;
    background-color: #f5f5f5;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .header-left {
      height: 35px;
      display: flex;
      align-items: center;
      .time {
        margin-right: 30px;
      }
    }
  }
  .item-content {
    display: flex;
    padding: 0 20px;
    .order-list {
      width: 100%;
    }
    .operation {
      width: 10%;
      display: flex;
      justify-content: center;
      align-items: center;
      color: #027cff;
      cursor: pointer;
    }
  }
  .order-item {
    width: 100%;
    height: 45px;
    display: flex;
    align-items: center;
  }
}
.blank-replace {
  height: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #909399;
  border-bottom: 1px solid #ebeef5;
}
.name {
  width: 30%;
}
.code {
  width: 10%;
}
.quality {
  width: 10%;
  display: flex;
  align-items: center;
}
.brand {
  width: 5%;
}
.model {
  width: 10%;
}
.module {
  width: 10%;
}
.category {
  width: 10%;
}
.quantity {
  width: 10%;
}
.price {
  width: 5%;
}
.operation {
  width: 10%;
  text-align: center;
}
.pagination-wrapper {
  margin-top: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
